import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { AuditableEntityType } from '@shared/enums/auditable-entity-type';
import { RestAuditModel } from '@shared/interfaces/audit.interface';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  constructor(private restApiService: RestapiService) {}

  getChangesHistory(objectId: number, objectType: AuditableEntityType): Observable<RestAuditModel[]> {
    return this.restApiService.getData<RestAuditModel[]>(`Audit/${objectId}/${objectType}`);
  }
}
